import { render, staticRenderFns } from "./TabsBar.vue?vue&type=template&id=2b0a6bcc&scoped=true"
import script from "./TabsBar.vue?vue&type=script&lang=js"
export * from "./TabsBar.vue?vue&type=script&lang=js"
import style0 from "./TabsBar.vue?vue&type=style&index=0&id=2b0a6bcc&prod&scoped=true&lang=css"
import style1 from "./TabsBar.vue?vue&type=style&index=1&id=2b0a6bcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a6bcc",
  null
  
)

export default component.exports